import { render } from "./ReactionBar.vue?vue&type=template&id=9e98dc6e&scoped=true&bindings={\"reactionBar\":\"setup\",\"widthCssRule\":\"setup\",\"handleReaction\":\"setup\"}"
import script from "./ReactionBar.vue?vue&type=script&lang=ts"
export * from "./ReactionBar.vue?vue&type=script&lang=ts"

import "./ReactionBar.vue?vue&type=style&index=0&id=9e98dc6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e98dc6e"

export default script